/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, inject, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { uuid } from '@src/app/model/abstract-object';
import { ServiceRequest } from '@src/app/model/serviceRequest';
import { ServiceRequestPageNavRoute } from '@src/app/routes/service-request-page-nav';
import { ChosenWidget, IWidget } from '@src/app/shared/dashboard/DashboardTypes';
import { MessageService } from '@src/app/shared/message.service';
import { TenantService } from '@src/app/shared/tenant.service';

class RequestSummaryItem {
    forumId: uuid;
    forumName: string;
    requests: string;
}

@Component({
    selector: 'app-request-summary',
    imports: [RouterLink, MatCardModule],
    templateUrl: './request-summary-widget.component.html',
    styleUrls: ['../../../../shared/dashboard/hello-world-widget/widget.component.scss']
})
export class RequestSummaryWidgetComponent  implements IWidget, OnInit {
  title = $localize `Open Requests Summary`;
  host: ElementRef<Element> = inject(ElementRef);
  options: { name: string; action: () => void; }[];
  @Input() chosenWidget: ChosenWidget;

  http = inject(HttpClient);
  tenantSvc = inject(TenantService);
  msgSvc = inject(MessageService);

  routerLink = ServiceRequestPageNavRoute.getListRouterLink({srStatus: ServiceRequest.srOpen.id});

  data: RequestSummaryItem[] = []; 

  ngOnInit(): void {
    this.http.get<{rows: RequestSummaryItem[]}>(this.tenantSvc.getPath('omc/dashboard/requestSummary')).subscribe( 
        data => this.data = data.rows,
        error => this.msgSvc.showError(error, 'Request Summary')
    );
  }

  navigateForum(rsi: RequestSummaryItem) {
    return ServiceRequestPageNavRoute.getListRouterLink({srStatus: ServiceRequest.srOpen.id, forumId: rsi.forumId || 'NULL'})
  }
}
